export enum AppointmentStatus {
    REQUESTED = 'requested',
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    COMPLETED = 'completed',
    THERAPIST_CANCELLED = 'cancelled_by_therapist',
    PATIENT_CANCELLED = 'cancelled_by_patient',
    REJECTED = 'rejected',
    DELETED = 'deleted',
}

export enum PlanBilledEnum {
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
    WEEKLY = 'weekly',
}

export enum ResultStatus {
    SUCCESS = 'success',
    FAILURE = 'failure',
}

export enum AuthPermission {
    ACCESS_MOBILE_APP= 'access:mobileapp',
    READ_OWN_PATIENT_DATA = 'read:ownpatientdata',
    WRITE_OWN_PATIENT_DATA = 'write:ownpatientdata',
    ACCESS_WEB_APP = 'access:webapp',
    READ_PATIENT_DATA = 'read:patientdata',
    WRITE_PATIENT_DATA = 'write:patientdata',
    ACCESS_TENANT_ADMIN = 'access:tenantadmin',
    ACCESS_SUPER_ADMIN = 'access:superadmin',
}

export enum ExerciseType {
    STATIC = 'static',
    DYNAMIC = 'dynamic',
    RELAXATION = 'relaxation',
    ENDURANCE = 'endurance',
    TEACHING = 'teaching',
}

export enum FileType {
    VERTICAL_VIDEO = 'vertical',
    HORIZONTAL_VIDEO = 'horizontal',
    VERTICAL_THUMBNAIL = 'vthumbnail',
    HORIZONTAL_THUMBNAIL = 'hthumbnail',
    AUDIO = 'audio'
}

export enum EntityScope {
    CORE = "core",
    TENANT = "tenant",
}

export enum AvailableFeatureEnum {
    INSURANCE_PLAN = 'INSURANCE_PLAN',
}

export enum PatientTherapyStatus {
    PLANNED = 'planned',
    STARTED = 'started',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}

export enum TherapyBillStatus {
    PAYED ='payed',
    OPEN = 'open',
    PLANNED = 'planned',
}

export enum TherapyStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export enum TrainingPlanStatus {
    UNPUBLISHED = 'unpublished',
    PUBLISHED = 'published',
    DELETED = 'deleted',
    DRAFT = 'draft',
}

export enum TrainingType {
    STRENGTH = 'strength',
    ENDURANCE = 'endurance',
}

export enum PromQuestionType {
    MULTIPLE = 'multiple',
    NUMBER = 'number',
    TEXT = 'text',
    RANGE = 'range',
}

export enum PromTriggerType {
    AFTER_EVERY_TRAINING = 'after_every_training',
    WEEKLY = 'weekly',
    AFTER_ENDURANCE_TRAINING = 'after_endurance_training',
}

export enum PromMetric {
    STEPS = 'steps',
    DISTANCE = 'distance',
    HEART_RATE = 'heart_rate',
}

export enum TrainingAnswer {
    BLANK_ANSWER = '',
    NOT_FIT = 'not_fit',
    NO_TIME = 'no_time',
    NO_ANSWER = 'no_answer',
}

export enum ExerciseAnswer {
    BLANK_ANSWER = '',
    NOT_FIT = 'not_fit',
    NO_TIME = 'no_time',
    NO_ANSWER = 'no_answer',
}

export enum ExerciseStatus {
    DONE = 'done',
    ABORTED = 'aborted',
    SKIPPED = 'skipped',
    DONE_WITH_SKIPS = 'done_with_skips',
}

export enum TrainingStatus {
    DONE = 'done',
    ABORTED = 'aborted',
    SKIPPED = 'skipped',
    DONE_WITH_SKIPS = 'done_with_skips',
}

export enum SessionStatus {
    ACTIVE = 'active',
    DONE = 'done',
}

export enum Language {
    GERMAN = 'de',
    ENGLISH = 'en',
}
